export interface ChecklistDTO {
  job_id: string
  sections: SectionDTO[]
}

export interface SectionDTO {
  id: string
  name: string
  heading: string
  description: string
  requested_supporting_items: RequestedSupportingItemDTO[]
}

export interface RequestedSupportingItemDTO {
  id: string
  name: string
  heading: string
  short_description: string
  long_description: string
  image_url?: string
  preview_url?: string
  required: boolean
  completed: boolean
  update_time: string | undefined
  input: SupportingItemInputDTO
}

export interface SupportingItemInputDTO {
  type: SupportingItemInputTypeDTO
}

export type SupportingItemInputTypeDTO = DocumentSupportingItemInputTypeDTO

export interface DocumentSupportingItemInputTypeDTO {
  // Just to make the mapping easier, I miss C# :(
  discriminator: SupportingItemInputTypeDiscriminatorDTO.DOCUMENT
  document: {
    document_type_short_id: string
    document_ids: string[]
  }
}

export enum SupportingItemInputTypeDiscriminatorDTO {
  DOCUMENT,
}
